import React from 'react';
import { Link } from 'react-router-dom';
import styles from './TopBar.module.css';

const TopBar = () => {
  return (
    <div className={styles.topBar}>
      <div className={styles.container}>
        <div className={styles.leftSection}>
          <Link to="/blog" className={styles.link}>Knowledge Base</Link>
        </div>
        <div className={styles.rightSection}>
          <Link to="/business" className={styles.link}>VastuLens for Business</Link>
        </div>
      </div>
    </div>
  );
};

export default TopBar;
